/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Location: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.75909 6.26572C8.8847 5.13457 10.4103 4.5 12 4.5C13.5897 4.5 15.1153 5.13457 16.2409 6.26572C17.3667 7.39703 18 8.93246 18 10.5345C18 12.4645 16.9626 14.3465 15.6066 15.9606C14.2994 17.5167 12.7976 18.7029 12 19.2826C11.2024 18.7029 9.70058 17.5167 8.39336 15.9606C7.0374 14.3465 6 12.4645 6 10.5345C6 8.93246 6.63333 7.39703 7.75909 6.26572ZM12 2.5C9.87668 2.5 7.84132 3.34769 6.34141 4.85498C4.84167 6.36212 4 8.40519 4 10.5345C4 13.158 5.38697 15.4912 6.86201 17.2471C8.35225 19.021 10.0444 20.3386 10.8905 20.9485C11.5571 21.4289 12.4429 21.4289 13.1095 20.9485C13.9556 20.3386 15.6478 19.021 17.138 17.2471C18.613 15.4912 20 13.158 20 10.5345C20 8.40519 19.1583 6.36212 17.6586 4.85498C16.1587 3.34769 14.1233 2.5 12 2.5ZM13.9999 10.5C13.9999 11.6046 13.1044 12.5 11.9999 12.5C10.8953 12.5 9.99988 11.6046 9.99988 10.5C9.99988 9.39543 10.8953 8.5 11.9999 8.5C13.1044 8.5 13.9999 9.39543 13.9999 10.5Z'
      fill='currentColor'
    />
  </React.Fragment>
)
